module.exports = __webpack_public_path__ + "static/media/orange-box-hover.624ee9e4.png";